import _extends from "@babel/runtime/helpers/esm/extends";
import React, { useContext } from 'react';
import ContextConnectedComponent from './ContextConnectedComponent';
export default function connectToContext(Context, mapContextToProps) {
  if (mapContextToProps === void 0) {
    mapContextToProps = function mapContextToProps(c) {
      return c;
    };
  }

  return function contextConnector(Component) {
    return function ContextConnection(props) {
      var contextValues = useContext(Context);
      var contextProps = mapContextToProps(contextValues, props);
      /* eslint-disable react/jsx-props-no-spreading */

      return /*#__PURE__*/React.createElement(ContextConnectedComponent, _extends({
        Component: Component
      }, contextProps, props));
      /* eslint-enable react/jsx-props-no-spreading */
    };
  };
}